var map = {
	"./addIcon.svg": 4650,
	"./bro.svg": 4478,
	"./bronze.svg": 8464,
	"./calendar-outline.svg": 7361,
	"./facebook.svg": 1693,
	"./gold.svg": 3215,
	"./instagram.svg": 2770,
	"./legacy.svg": 9777,
	"./linkedIn.svg": 7012,
	"./location-outline.svg": 9632,
	"./location.svg": 2483,
	"./mail.svg": 2059,
	"./marker.svg": 690,
	"./p1icons.svg": 1379,
	"./silver.svg": 2067,
	"./svg/logo/dark (D)/logo_dark_main.svg": 1530,
	"./svg/logo/dark (D)/logo_dark_slogan.svg": 2813,
	"./svg/logo/dark (D)/logo_dark_slogan_vertical.svg": 8114,
	"./svg/logo/dark (D)/logo_dark_year.svg": 8035,
	"./svg/logo/dark (D)/logo_dark_year_slogan.svg": 527,
	"./svg/logo/light (L)/logo_light_main.svg": 3157,
	"./svg/logo/light (L)/logo_light_slogan.svg": 5281,
	"./svg/logo/light (L)/logo_light_year.svg": 8381,
	"./svg/logo/light (L)/logo_light_year_slogan.svg": 2866,
	"./svg/logo/white (W)/logo_white_main.svg": 3196,
	"./svg/logo/white (W)/logo_white_slogan.svg": 1511,
	"./svg/logo/white (W)/logo_white_year.svg": 5350,
	"./svg/logo/white (W)/logo_white_year_slogan.svg": 1667,
	"./svg/social_icons/social_icon_circle_dark.svg": 8586,
	"./svg/social_icons/social_icon_circle_light.svg": 3896,
	"./svg/social_icons/social_icon_square_dark.svg": 2398,
	"./svg/social_icons/social_icon_square_light.svg": 8553,
	"./tiktok.svg": 8583,
	"./time-outline.svg": 7009,
	"./x.svg": 1112
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 968;